module.exports = __webpack_public_path__ + "static/media/violin.f684181c.mp3";